import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from 'src/app/material-module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BrandingComponent } from './branding.component';
import { CreateUpdateTemplateComponent } from './create-update-template/create-update-template.component';
import { PreviewTemplateComponent } from './preview-template/preview-template.component';
import { TemplateDetailsComponent } from './template-details/template-details.component';


const BrandingRoutes: Routes = [
  {
    path: '',
    component: BrandingComponent
  }
];

@NgModule({
  declarations: [
    BrandingComponent,
    PreviewTemplateComponent,
    TemplateDetailsComponent,
    CreateUpdateTemplateComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatDialogModule,
    ReactiveFormsModule,
    SharedModule,
    PipesModule,
    RouterModule.forChild(BrandingRoutes)
  ],
  exports: [BrandingComponent]
})

export class BrandingModule { }
